import DbApiCaller                from './DbApiCaller';
import DialogDownload             from './dialogs/DialogDownload';
import DialogQuotaExceededError   from './dialogs/DialogQuotaExceededError';
import DialogExceptionError       from './dialogs/DialogExceptionError';
import DialogNotCompatibleError   from './dialogs/DialogNotCompatibleError';
import DialogStorageDisabledError from './dialogs/DialogStorageDisabledError';




const TABLE_NAME_RESOLVES = {
  '@offers': [
    'offers',
    'offers_moshi',
    // 'universities',
    // 'passing_scores',
    // 'center_subjects',
    // 'special_subjects',
    // 'offer_schedules',
  ],
};

const resolveTableNames = names => {
  names = typeof names === 'string' ? [names] : names;

  const results = [];
  names.forEach(name => {
    const alias = TABLE_NAME_RESOLVES[name];
    if (alias) {
      alias.forEach(row => { results.push(row) });
    } else {
      results.push(name);
    }
  });
  return results;
}

const NOT_SUPPORT_ERROR_MESSAGE = 'IndexedDB の動作保証環境でありません';



export default {
  data() {
    return {
      detectState               : 'pending',
      support                   : true,
      privateBrowse             : false,
      browserVersionIsNotSupport: false,
      storageIsDisabled         : false,

      progress: {
        message: null,
        value  : 0,
      },
    }
  },

  computed: {
    isDetcting() { return this.detectState === 'detcting' },
    isDetcted() { return this.detectState === 'detcted' },
  },



  methods: {

    /**
     * 進捗をセットする
     */
    setProgress(progress = {message: null, value: 0}) {
      progress = typeof progress === 'number' ? {value: progress} : progress;
      ['message', 'value'].forEach(key => {
        if (progress[key] !== undefined) this.$set(this.progress, key, progress[key]);
      });
    },



    /**
     * テーブルのステータスを確認する
     */
    getTablesStatus(names) {
      return new Promise(async (resolve, reject) => {
        try {
          await this.checkNotSupport();
        } catch(e) {
          return reject(e);
        }

        names = resolveTableNames(names);
        try {
          const result = await this.api.call('getTablesStatus', {tables: names});
          return resolve(result);
        } catch(e) {
          this.showErrorDialog();
          return reject(e);
        }
      });
    },



    /**
     * データをダウンロードする
     * ※完了するまでダイアログを表示
     */
    async download(names, opt = {}) {
      await this.checkNotSupport();

      names = resolveTableNames(names);

      this.setProgress();
      this.$refs[`dialog-download`].show();

      // 現在のテーブルのステータスを取得する
      const [dbStates, currentStatus] = await Promise.all([
        new Promise((resolve, reject) => {
          resolve(JSON.parse(JSON.stringify(dn.$ls.get('db_states', {}))));
        }),
        this.getTablesStatus(names),
      ]);

      const targets = [];

      // ダウンロードの必要のない物はスキップする
      names.forEach(name => {
        // if (!currentStatus.exist.includes(name)) targets.push(name);
        // DN回の場合、模試回のマスタもダウンロードする
        if (name !== "offers_moshi" || dn.$store.getters['config/kai'].substr(4, 3) === "308") {
          targets.push(name);
        }
      });

      // ダウンロード対象のローカルストレージのテーブルの状態を削除しておく
      targets.forEach(name => {
        delete dbStates[name];
      });
      dn.$ls.set('db_states', dbStates);

      let downloadResult;

      try {
        downloadResult = await this.api.call('download', {tables: targets, skipSyncDbStates: true}, {
          onProgress: e => {
            this.setProgress(e);
            if (typeof opt.onProgress === 'function') return opt.onProgress(e);
          },
        });
      } catch(e) {
        this.$refs[`dialog-download`].hide();

        const description = e.description || '';
        if (description.match('QuotaExceededError')) {

          // >>> 容量不足のエラー
          this.showErrorDialog('quota-exceeded');
          throw new Error(e.description);
        } else {

          // >>> 例外エラー
          this.showErrorDialog();
          throw new Error(e);
        }
      }

      // ダウンロード完了後にテーブル状態をローカルストレージに保持する
      // ※スキップされているテーブルもあるかもしれないので、返却されたキーのものだけにする
      for (let name in downloadResult) {
        dbStates[name] = downloadResult[name];
      }

      dn.$ls.set('db_states', dbStates);

      this.$refs[`dialog-download`].hide();
      return downloadResult;
    },



    /**
     * 募集単位を検索する
     */
    async searchOffers(conditions) {
      await this.checkNotSupport();
      try {
        return await this.api.call('searchOffers', {conditions: conditions});
      } catch(e) {
        this.showErrorDialog();
        throw new Error(e);
      }
    },



    /**
     * 合格者最低点・平均点一覧を募集単位基準で検索する
     */
    async searchOfferWithPassingScores(conditions) {
      await this.checkNotSupport();
      try {
        return await this.api.call('searchOfferWithPassingScores', {conditions: conditions});
      } catch(e) {
        this.showErrorDialog();
        throw new Error(e);
      }
    },



    /**
     * エラーダイアログを表示する
     */
    showErrorDialog(type = 'exception') {
      // 新大学データダウンロード対応
      if (type === 'exception') {
        const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        let request = indexedDB.deleteDatabase('dn_db_2019');
        request = indexedDB.deleteDatabase('dn_db_2018');
        if (sessionStorage.getItem("error") == undefined) {
          location.reload();
          sessionStorage.setItem("error","1");
        } else {
          sessionStorage.setItem("error","0");
          return this.$refs[`dialog-${type}-error`].show();
        }
        return;
      } else {
        return this.$refs[`dialog-${type}-error`].show();
      }
    },



    /**
     * 容量チェック（デバッグ用）
     */
    checkSize() {
      const onError = e => {
        console.error(e);
        alert('容量のチェックができませんでした。');
      }

      try {
        navigator.webkitTemporaryStorage.queryUsageAndQuota(
          (usedBytes, grantedBytes) => {
            const usedMb  = Math.round(usedBytes * 10 / 1000 / 1000) / 10;
            const usedGb  = Math.round(usedMb * 10 / 1000) / 10;
            const totalMb = Math.round(grantedBytes * 10 / 1000 / 1000) / 10;
            const totalGb = Math.round(totalMb * 10 / 1000) / 10;

            console.log('we are using ', usedBytes, ' of ', grantedBytes, 'bytes');

            alert(
              '使ってる容量: ' + usedMb + 'MB（' + usedGb + 'GB）\n' +
              '使える容量: ' + totalMb + 'MB（' + totalGb + 'GB）\n'
            );
          },
          onError
        );
      } catch(e) {
        onError(e);
      }
    },



    /**
     * サポート状況をチェック＆保持する
     */
    detectSupport() {
      if (this.isDetcted) return Promise.resolve(this.support);

      return new Promise(async (resolve) => {
        this.on('detect', () => {
          resolve(this.support);
        });

        if (this.isDetcting) return;

        this.detectState = 'detcting';

        await dn.$store.dispatch('browser/ready');

        if (!dn.$store.getters['browser/idbEnabled']) {
          this.support = false;

          if (dn.$store.getters['browser/isPrivateBrowse']) {
            this.privateBrowse = true;
          } else if (!dn.$store.getters['browser/storageEnabled']) {
            this.storageIsDisabled = true;
          } else if (dn.$store.getters['browser/isIdbNotSupport']) {
            this.browserVersionIsNotSupport = true;
          }
        }

        this.detectState = 'detcted';
        this.emit('detect');
      });
    },



    /**
     * 未サポートをチェックしてそうであればエラーをスローする
     */
    async checkNotSupport() {
      if (!await this.detectSupport()) {
        this.showNotSupportDialog();
        throw new Error(NOT_SUPPORT_ERROR_MESSAGE);
      }
    },



    /**
     * 未サポートダイアログを表示
     */
    showNotSupportDialog() {
      let dialogName;
      if (this.browserVersionIsNotSupport) dialogName = 'not-compatible';
      if (this.storageIsDisabled || this.privateBrowse) dialogName = 'storage-disabled';

      return this.showErrorDialog(dialogName);
    },
  },



  async created() {
    new EventManager(this);

    this.api = new DbApiCaller();
    await this.detectSupport();
  },




  render(h) {
    const $container = h('div', {
      attrs: {
        class: 'dn-db-manager',
      },
    }, [
      h(DialogDownload, {
        ref: 'dialog-download',

        props: {
          message: this.progress.message,
          value  : this.progress.value,
        },
      }),

      h(DialogNotCompatibleError, {
        ref: 'dialog-not-compatible-error',
      }),

      h(DialogStorageDisabledError, {
        ref: 'dialog-storage-disabled-error',
        props: {
          privateBrowse: this.privateBrowse,
          storageIsDisabled: this.storageIsDisabled,
        },
      }),

      h(DialogExceptionError, {
        ref: 'dialog-exception-error',
      }),

      h(DialogQuotaExceededError, {
        ref: 'dialog-quota-exceeded-error',
      }),

    ]);
    return $container;
  },
}



// WEBPACK FOOTER //
// ./src/js/manager/DbManager/DbManager.js